<template>
  <div class="layout-main bg-white">
    <div class="journey detail custom-z-index" v-if="journeyData">
      <div class="header journey-block" v-if="isOwner || isMember">
        <div class="fs-h2 text-md-center" v-text="journeyData.name"></div>
        <div class="option-btn-group d-flex justify-content-md-center">
          <button class="btn common-oval-btn dark fs-capation-12" @click="downloadGPXClicked">GPX</button>
          <button class="btn common-oval-btn dark fs-capation-12" @click="downloadDiagramClicked">軌跡圖</button>
          <button class="btn common-oval-btn dark fs-capation-12" @click="planBookClicked">計劃書</button>
        </div>
        <b-dropdown class="more-option" variant="link" right no-caret>
          <template #button-content>
            <Icon name="more_horiz" size="24" />
          </template>
          <b-dropdown-item-button v-if="isOwner && isExpired" button-class="d-flex justify-content-between align-items-center" @click="groupDuplicate">
            <span>建立新團</span>
            <Icon name="paste" size="24" />
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="isOwner && !isExpired" button-class="d-flex justify-content-between align-items-center" @click="journeyEdit">
            <span>編輯行程</span>
            <Icon name="edit" size="24" />
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="isOwner && !isExpired" button-class="d-flex justify-content-between align-items-center" @click="toMemberEdit">
            <span>團員管理</span>
            <Icon name="user-group-solid" size="24" />
          </b-dropdown-item-button>
          <b-dropdown-item-button button-class="d-flex justify-content-between align-items-center" @click="copyLinkClicked">
            <span>分享行程</span>
            <Icon name="share" size="24" />
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="isOwner" button-class="d-flex justify-content-between align-items-center" @click="deleteBtnClicked">
            <span>刪除行程</span>
            <Icon name="volume" size="24" />
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="isMember && !isExpired" button-class="d-flex justify-content-between align-items-center" @click="quitBtnClicked">
            <span>退出行程</span>
            <Icon name="quit" size="24" />
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
      <div class="header journey-block d-flex justify-content-md-center" v-if="!isExpired && !isOwner && !isMember">
        <button class="btn common-oval-btn dark fs-capation-12 apply-btn" @click="toMemberJoin">加入此登山活動</button>
      </div>
      <div class="journey-content journey-block">
        <div class="block-title fs-h4 pt-3" v-if="isOwner || isMember">計畫內容</div>
        <div class="operating-list">
          <div class="operating-item" v-if="!isOwner && joinedMembers">
            <div class="name">
              <div class="fs-body-16">主辦人</div>
            </div>
            <div class="info">
              <div class="master-info d-flex align-items-center">
                <div class="avatar circle-32px">
                  <img :src="joinedMembers.owner?.pic_url" alt="avatar">
                </div>
                <span class="fs-title-14" v-text="joinedMembers.owner?.name"></span>
              </div>
            </div>
          </div>
          <div class="operating-item" v-if="!isOwner && !isMember">
            <div class="name">
              <div class="fs-body-16">行程路線</div>
            </div>
            <div class="info">
              <div class="fs-h4" v-text="groupData.name"></div>
            </div>
          </div>
          <div class="operating-item">
            <div class="name">
              <div class="fs-body-16">出發日期</div>
            </div>
            <div class="info">
              <div class="fs-title-18">{{ moment(journeyData.journey[0].startTimestamp).format('YYYY/MM/DD (dd) HH:mm') }}</div>
            </div>
          </div>
          <div class="operating-item">
            <div class="name">
              <div class="fs-body-16">下山時間</div>
            </div>
            <div class="info">
              <div class="fs-title-18">{{ moment(journeyData.journey[journeyData.journey.length - 1].endTimestamp).format('YYYY/MM/DD (dd) HH:mm') }}</div>
            </div>
          </div>
          <div class="operating-item">
            <div class="name">
              <div class="fs-body-16">行程天數</div>
            </div>
            <div class="info">
              <div class="fs-title-18" v-text="durationDays"></div>
            </div>
          </div>
          <router-link :to="{name: 'GroupDetailSubmit'}" class="operating-item" v-if="isOwner || isMember">
            <div class="name">
              <div class="fs-body-16">申請資訊</div>
            </div>
            <div class="info">
              <span class="fs-title-18" v-text="startRegMsg"></span>
              <span class="fs-body-18" v-if="passRule.areaHouseRule"> [預先登記後抽籤]</span>
            </div>
          </router-link>
          <div class="operating-item cursor-pointer" v-if="isOwner || isMember" @click="openPageModal">
            <div class="name">
              <div class="fs-body-16">參與人員</div>
            </div>
            <div class="info">
              <div class="fs-title-18" v-text="participantCount"></div>
            </div>
          </div>
<!--          <div class="operating-item">-->
<!--            <div class="name">-->
<!--              <div class="fs-body-16">接駁服務</div>-->
<!--            </div>-->
<!--            <div class="info">-->
<!--              <div class="fs-title-18">尚未預訂接駁</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="journey-plan journey-block">
        <div class="block-title fs-h4">路線規劃</div>
        <div class="content-list">
          <div class="content-item d-flex justify-content-between">
            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="directions_walk" size="20" />
                <div class="info-text fs-body-16">行走</div>
              </div>
              <div class="info-value fs-h2">
                <span v-text="formatTimeToHoursAndMinutes(journeyData.pathInfo.totalWalkTime)"></span>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="distance" size="20" />
                <div class="info-text fs-body-16">距離</div>
              </div>
              <div class="info-value fs-h2">
                <span>{{ Math.round(journeyData.pathInfo.totalDistance / 1000 * 10) / 10 }}</span>
                <span class="unit">km</span>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="climb-up" size="20" />
                <div class="info-text fs-body-16">總升</div>
              </div>
              <div class="info-value fs-h2">
                <span>{{ journeyData.pathInfo.totalUp }}</span>
                <span class="unit">m</span>
              </div>
            </div>

            <div class="d-flex flex-column align-items-center px-2">
              <div class="info-name d-flex align-items-center">
                <Icon class="info-icon" name="climb-down" size="20" />
                <div class="info-text fs-body-16">總降</div>
              </div>
              <div class="info-value fs-h2">
                <span>{{ journeyData.pathInfo.totalDown }}</span>
                <span class="unit">m</span>
              </div>
            </div>
          </div>
          <div class="content-item">
            <div class="name">
              <div class="fs-body-16">行走速率</div>
            </div>
            <div class="info">
              <div class="fs-title-18" v-if="climbRateStatus !== -1">x {{ climbRateStatus }} (標準)</div>
              <div class="climb-rate-group" v-if="climbRateStatus === -1">
                <div class="day-climb-rate" v-for="(item, index) in journeyData.climbRateArray" :key="index">
                  <div class="fs-body-16 climb-rate-text" v-text="'Day' + ( index + 1 )"></div>
                  <div class="climb-rate-number fs-title-18">
                    <span>x</span>
                    <span v-text="item"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-item">
            <div class="journey-info row">
              <div class="col-12 col-md-6">
                <div class="box trail-map" :class="{ 'scale-active': mapScale }">
                  <img class="thumbnail d-md-none" :src="[journeyData.picUrl]" alt="路線縮圖">
                  <button class="btn scale d-md-none" @click="mapScaleToggle">
                    <Icon :name="mapScale ? 'map-reduce' : 'map-enlarge'" size="24" alt="地圖縮放鍵" class="map-scale-btn" />
                  </button>
                  <div class="path-map-group custom-z-index common-transition">
                    <path-map ref="map" :milestones="shownPathMilestones" :journeyContent="journeyData.journey" @toggle-map-scale="mapScaleToggle" :hideScaleBtn="!isMobile" hideSwapBtn></path-map>
                    <!-- <button class="btn scale d-md-none" @click="mapScaleToggle">
                      <Icon :name="mapScale ? 'map-reduce' : 'map-enlarge'" size="24" alt="地圖縮放鍵" class="map-scale-btn" />
                    </button> -->
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="box overflow-auto">
                  <journey-viewer :journey="journeyData" showHeaderInfo :show-opt-btn="false" :show-weather="false" :show-start-time-select="false"></journey-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-if="journeyData" modal-class="download-diagram" ref="diagram-modal" size="lg" centered hide-header hide-footer v-model="showDiagramModal">
      <path-download-diagram :path-serial="journeyData.baseOnPathSerial" :path-info="journeyData" :window-width="windowWidth" @close-modal="downloadDiagramClicked()">
        <journey-drawer class="d-none" v-if="drawerDataReady" style="width: 100%" ref="rcanvas" :size="1000" :showInfo="true" :journey="journeyData" :day-index="-1" :hide-blank-milestones="drawConfig.hideBlankMilestones" :config="drawConfig.config" :title="journeyData.name"></journey-drawer>
      </path-download-diagram>
    </b-modal>

    <transition name="fade">
      <pageModal v-if="pageModalOpen" title="參與人數" :desc="joinedMembersNumber" back-btn-type="back" :optionBtn="false" @close="closePageModal" >
        <GroupDetailMember ref="member" :groupData="groupData" :journeyData="journeyData" :joinedMembers="joinedMembers" @back="closePageModal" @generate-share-code-clicked="generateShareCode" />
      </pageModal>
    </transition>

  </div>
</template>

<script>
import moment from "moment/moment";
import JourneyViewer from "@/components/common/JourneyViewer.vue";
import PathMap from "@/components/common/PathMap.vue";
import PathDownloadDiagram from "@/views/path/PathDownloadDiagram.vue";
import JourneyDrawer from "@/components/common/JourneyDrawer.vue";
import {mapState} from "vuex";
import pageModal from "@/components/common/pageModal.vue";
import GroupDetailMember from "@/views/group/GroupDetailMember.vue";

export default {
  name: 'GroupDetail',
  data() {
    return {
      readInfoBusyName: 'READINFOBUSY',
      updateInfoBusyName: 'UPDATEINFOBUSY',

      groupData: null,
      journeyData: null,
      shownPathMilestones: [],
      joinedMembers: {},
      passRule: {},
      parkPassDesc: [],
      mountainPassDesc: [],
      startRegMsg: '',
      tempId: -1,

      windowWidth: window.innerWidth,
      showDiagramModal: false,
      drawConfig: {
        hideBlankMilestones: false,
        config: null,
      },
      drawerDataReady: false,

      mapScale: false,
      pageModalOpen: false,
    };
  },
  props: {
  },
  components: {
    pageModal, GroupDetailMember,
    JourneyDrawer, PathDownloadDiagram,
    PathMap,
    JourneyViewer,
  },
  computed: {
    ...mapState(['user']),

    isOwner() {
      return this.user && this.user.serial === this.groupData?.groupMasterSerial;
    },
    isMember() {
      if (!this.user) {
        return false;
      }
      return this.joinedMembers.groupList ? this.joinedMembers.groupList.some(member => member.userSerial === this.user.serial) : false;
    },
    isExpired() {
      const theDayAfterEndDate = moment(this.journeyData.endDate);
      theDayAfterEndDate.add(1, 'day');
      return moment().isAfter(theDayAfterEndDate);
    },
    moment() {
      return moment
    },
    durationDays() {
      const dayMappings = {
        1: '單攻',
      };

      for (let i = 2; i <= 9; i++) {
        dayMappings[i] = `${i}天`;
      }

      if (this.journeyData && this.journeyData.durationDays in dayMappings) {
        return dayMappings[this.journeyData.durationDays];
      } else {
        return '資料獲取失敗';
      }
    },
    participantCount() {
      return this.joinedMembers.groupList ? this.joinedMembers.groupList.length + 1 : 1;
    },
    joinedMembersNumber() {
      return this.joinedMembers.groupList && this.groupData.joinLimit ? '（ ' + (this.joinedMembers.groupList.length + 1) + ' / '+ this.groupData.joinLimit + ' ）' : '';
    },
    journey() {
      return this.journeyData;
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    climbRateStatus() {
      const arr = this.journeyData.climbRateArray;

      // 空陣列 → 回傳 -1
      if (!arr || arr.length === 0) return -1;

      // 只有一個數字 → 回傳該數字
      if (arr.length === 1) return arr[0];

      // 多於一個 → 檢查是否全部相同
      const first = arr[0];
      const allSame = arr.every(num => num === first);

      return allSame ? first : -1;
    }
	},
  watch: {
    
  },
  async mounted() {
    await this.refresh();
	},
  methods: {
    async refresh() {
      const journeyId = this.$route.params.id;
      await this.readInfo(journeyId);
      this.__calcParkPassDesc();
      this.__calcMountainPassDesc();
      this.calcStartRegMsg();
    },
    async readInfo(journeyId) {
      await this.$store.dispatch('appendComponentBusy', this.readInfoBusyName);
      try {
        const groupData = await this.$store.dispatch('api/getGroupDetailPromise', journeyId);
        this.groupData = Object.assign({}, groupData);
        this.journeyData = await this.$store.dispatch('api/getJourneyDetailPromise', this.groupData.journeys[0]);
        this.buildPathMilestones(this.journeyData.journey);
        // const dayTemplatesRequest = await this.$store.dispatch('api/getPathDayTemplatePromise', this.journeyData.baseOnPathSerial);
        // const targetTemp = dayTemplatesRequest.find(item => item.days === this.journeyData.durationDays);
        // this.tempId = targetTemp.serial;
        // const testIsJoinedRes = await this.$store.dispatch('api/postGroupTestIsJoinedPromise', this.groupData.serial);
        // if(testIsJoinedRes.isJoined) {
        //   this.joinedMembers = {};
        //   this.joinedMembers = await this.$store.dispatch('api/getGroupMembersPromise', this.groupData.serial);
        //   if (this.joinedMembers.groupList) {
        //     const userItem = this.joinedMembers.groupList.find(item => item.serial === this.user.serial);
        //     if (userItem) {
        //       this.joinedMembers.groupList = this.joinedMembers.groupList.filter(item => item.serial !== this.user.serial);
        //       this.joinedMembers.groupList.unshift(userItem);
        //     }
        //   }
        // }

        this.joinedMembers = {};
        this.joinedMembers = await this.$store.dispatch('api/getGroupMembersPromise', this.groupData.serial);
        if (this.joinedMembers.groupList && this.user) {
          const userItem = this.joinedMembers.groupList.find(item => item.serial === this.user.serial);
          if (userItem) {
            this.joinedMembers.groupList = this.joinedMembers.groupList.filter(item => item.serial !== this.user.serial);
            this.joinedMembers.groupList.unshift(userItem);
          }
        }

        this.passRule = await this.$store.dispatch('api/getJourneyPassRulePromise', this.groupData.journeys[0]);
        // this.calcStartRegMsg();
        this.drawerDataReady = true;
      } catch (error) {
        await this.$store.dispatch('appendErrorMsg', error.toString());
      } finally {
        await this.$store.dispatch('clearComponentBusy', this.readInfoBusyName);
      }
    },
    async generateShareCode() {
      await this.$store.dispatch('appendComponentBusy', this.updateInfoBusyName);
      try {
        await this.$store.dispatch('api/postGroupGenerateShareCode', this.groupData.serial);
        await this.refresh();
      } catch (error) {
        await this.$store.dispatch('appendErrorMsg', error.toString());
      } finally {
        await this.$store.dispatch('clearComponentBusy', this.updateInfoBusyName);
      }
    },
    formatTimeToHoursAndMinutes(value) {
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    },
    buildPathMilestones(journeyItems) {
      this.shownPathMilestones.splice(0, this.shownPathMilestones.length);

      for (const item of journeyItems) {
        if (item.type === 'milestone') {
          const found = this.shownPathMilestones.filter((m) => {
            return m.serial === item.detail.serial;
          });
          if (found.length === 0) {
            this.shownPathMilestones.push(item.detail);
          }
        }
      }
    },
    calcStartRegMsg() {
      try {
        let startDate = moment(this.journeyData.startDate);

        const formatDateWithYear = (dateStr) => {
          // 補上年份
          let dateWithYear = moment(`${startDate.year()}/${dateStr}`, 'YYYY/MM/DD');

          // 如果日期晚於 startDate，表示該日期屬於前一年
          if (dateWithYear.isAfter(startDate)) {
            dateWithYear.subtract(1, 'year');
          }

          return dateWithYear.format('YYYY/MM/DD');
        };

        if (this.passRule.areaHouseRule !== null) {
          if(this.parkPassDesc) {
            const firstDate = this.parkPassDesc.find((item) => {
              return item.date !== undefined;
            });
            const date = formatDateWithYear(firstDate.date);
            this.startRegMsg = `${date} 開始申請 ${this.passRule.areaHouseRule.houseName}`;
          } else {
            const date = formatDateWithYear(this.mountainPassDesc[0].date);
            this.startRegMsg = `${date} 申請入山證`;
          }
        } else {
          this.startRegMsg = '不須申請'
        }
      } catch (error) {
        console.error(error);
      }
    },
    // toChineseNumber(number) {
    //   const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    //   const units = ['', '十', '百', '千', '萬', '億', '兆'];
    //   const numberStr = number.toString();
    //   let result = '';
    //   for (let i = 0; i < numberStr.length; i++) {
    //     const digit = parseInt(numberStr[i]);
    //     if (digit !== 0) {
    //       result += chineseNumbers[digit] + units[numberStr.length - i - 1];
    //     } else {
    //       if (i === numberStr.length - 1 || parseInt(numberStr[i + 1]) !== 0) {
    //         result += chineseNumbers[digit];
    //       }
    //     }
    //   }
    //   return result;
    // },
    mapScaleToggle() {
      this.mapScale = !this.mapScale;
    },
    downloadGPXClicked() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupGPXDownload",
      });
      // const baseUrl = process.env.VUE_APP_BASE_URL;
      const journeyId = this.journeyData._id;
      const journeyGPXLink = this.$store.state.api.URLS.getJourneyGPX;
      
      const downloadUrl = `${window.location.protocol}//${window.location.host}${journeyGPXLink}/${journeyId}`;
      // console.log(downloadUrl);
      const fileName = `${this.groupData.name}_Joyhike.gpx`;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', downloadUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (this.status === 200 || this.status === 304) {
          var myBlob = this.response;
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(myBlob);
          link.download = fileName;
          link.click();
        }
      };
      xhr.send();
      // window.open(downloadUrl, '_blank');
    },
    downloadDiagramClicked() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupDiagram",
      });
      if (this.user === null) {
        this.$router.push({name: 'Login'});
      } else {
        this.showDiagramModal = !this.showDiagramModal;
      }
    },
    planBookClicked() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupPlanBook",
      });
      this.$router.push({
        name: 'GroupPlanBook',
      });
    },
    async journeyEdit() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupToEdit",
      });
      await this.$router.push({ name: 'GroupDetailEdit' });
    },
    async deleteBtnClicked() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupDelete",
      });
      let r = confirm('確定刪除【' + this.groupData.name + '】?');
      if (r) {
        try {
          await this.$store.dispatch('api/postGroupDeletePromise', this.groupData._id);
          alert('成功刪除【' + this.groupData.name + '】');
          await this.$router.push({ name: 'MyPlan' });
        } catch (error) {
          await this.$store.dispatch('appendErrorMsg', error.toString());
        }
      }
    },
    async quitBtnClicked() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupQuit",
      });
      if(this.isMember) {
        let r = confirm('確定離開【' + this.groupData.name + '】?');
        if (r) {
          try {
            await this.$store.dispatch('api/postGroupLeavePromise', this.groupData.serial);
            alert('成功離開【' + this.groupData.name + '】');
            await this.$router.push({ name: 'MyPlan' });
          } catch (error) {
            await this.$store.dispatch('appendErrorMsg', error.toString());
          }
        }
      }
    },
    async groupDuplicate() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupDuplicate",
      });
      let r = confirm('確定以【' + this.groupData.name + '】為藍本建立新團?');
      if (r) {
        try {
          const res = await this.$store.dispatch('api/postGroupDuplicatePromise', this.groupData._id);
          alert('成功以【' + this.groupData.name + '】為藍本建立新團，即將前往編輯新團');
          if(res && res.group._id) {
            await this.$router.push({ name: 'GroupDetailEdit', params: { id: res.group._id } });
          }
        } catch (error) {
          await this.$store.dispatch('appendErrorMsg', error.toString());
        }
      }
    },
    copyLinkClicked() {
      // window.copyMsg(window.location.href);
      // alert('已複製分享連結!');
      this.$gtag.event('CustomClick', {
        event_label: "GroupShare",
      });
      const url = window.location.href;

      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          alert('已複製分享連結!');
        }).catch(err => {
          console.error('Failed to copy URL: ', err);
          alert('複製分享連結失敗。');
        });
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          alert('已複製分享連結!');
        } catch (err) {
          console.error('Failed to copy URL: ', err);
          alert('複製分享連結失敗。');
        }
        document.body.removeChild(textArea);
      }
    },
    toMemberEdit() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupToMemberManage",
      });
      this.$router.push({ name: 'GroupDetailMember' });
    },
    toMemberJoin() {
      this.$gtag.event('CustomClick', {
        event_label: "GroupJoin",
      });
      if (this.user === null) {
        this.$store.commit('setRedirectRoute', window.location.pathname);
        this.$router.push({name: 'Login'});
      } else {
        this.$router.push({ name: 'GroupDetailMemberJoin' });
      }
    },
    openPageModal() {
      this.pageModalOpen = true;
    },
    closePageModal() {
      this.pageModalOpen = false;
    },
    isEmptyObject(obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },
    __calcParkPassDesc() {
      let d = moment(this.journey.startDate);
      const originDate = d.date();

      if (this.journey.durationDays > 1) {
        // 多日
        if (this.passRule.areaHouseRule !== null) {
          // 第一天住宿點為山屋且有設定區域
          this.parkPassDesc.push({
            text: this.passRule.areaHouseRule.houseName,
          });
          const areaRule = this.passRule.areaHouseRule;

          const endTime = moment(this.journey.startDate).subtract(5, 'day');
          endTime.set('hour', parseInt(areaRule.regCloseTime.split(':')[0]));
          endTime.set('minute', parseInt(areaRule.regCloseTime.split(':')[1]));
          let timeOver = false;
          if (moment().isAfter(endTime)) {
            timeOver = true;
          }

          if (areaRule.drawType === 0) {
            // 抽籤
            d.subtract(areaRule.regOpenDateRule === 0?2:1, 'month');
            if (d.date() !== originDate) {
              d.add(1, 'day');
            }
            const startRegMsg = {
              date: d.format('MM/DD'),
              time: areaRule.regOpenTime,
              text: '開始登記',
            };
            if (!timeOver) {
              startRegMsg.link = areaRule.regLink;
              startRegMsg.linkText = '前往登記';
              // this.setParkSubmitCalendar(d, areaRule.regOpenTime, areaRule.regLink);
            }
            this.parkPassDesc.push(startRegMsg);

            d = moment(this.journey.startDate).subtract(1, 'month');
            if (d.date() !== originDate) {
              d.add(1, 'day');
            }
            const drawMsg = {
              date: d.format('MM/DD'),
              time: areaRule.drawTime,
              text: '隨機抽籤',
            }
            if (!timeOver) {
              drawMsg.link = areaRule.regResultUrl.replace('{date}', moment(this.journey.startDate).format('YYYY-MM-DD'));
              drawMsg.linkText = '抽籤結果';
            }
            this.parkPassDesc.push(drawMsg);

            let dFrom = d.add(1, 'day');
            let dTo = moment(this.journey.startDate).subtract(6, 'day');
            const resMsg = {
              date: dFrom.format('MM/DD') + ' ~ ' + dTo.format('MM/DD'),
              text: '登記補抽',
            }
            if (!timeOver) {
              resMsg.link = areaRule.regLink;
              resMsg.linkText = '前往補抽';
            }
            this.parkPassDesc.push(resMsg);

            this.parkPassDesc.push({
              date: dTo.add(1, 'day').format('MM/DD'),
              time: areaRule.regCloseTime,
              text: '截止遞補',
            });
          } else {
            // 照順序
            d.subtract(areaRule.regOpenDateRule === 0?2:1, 'month');
            if (d.date() !== originDate) {
              d.add(1, 'day');
            }
            const startRegMsg = {
              date: d.format('MM/DD'),
              time: areaRule.regOpenTime,
              text: '依申請時間排序',
            };
            if (!timeOver) {
              startRegMsg.link =  areaRule.regLink;
              startRegMsg.linkText = '前往申請';
              // this.setParkSubmitCalendar(d, areaRule.regOpenTime, areaRule.regLink);
            }
            this.parkPassDesc.push(startRegMsg);

            let dFrom = d.add(1, 'day');
            let dTo = moment(this.journey.startDate).subtract(6, 'day');
            const reg2Msg = {
              date: dFrom.format('MM/DD') + ' ~ ' + dTo.format('MM/DD'),
              text: '登記遞補',
            };
            if (!timeOver) {
              reg2Msg.link =  areaRule.regLink;
              reg2Msg.linkText = '前往登記';
            }
            this.parkPassDesc.push(reg2Msg);

            this.parkPassDesc.push({
              date: dTo.add(1, 'day').format('MM/DD'),
              time: areaRule.regCloseTime,
              text: '截止遞補',
            });
          }
        } else {
          // 沒有山屋或沒有區域資料
          if (this.passRule.parkPass) {
            this.parkPassDesc.push({
              text: '此路線須申請入園證',
            });
          } else {
            this.parkPassDesc.push({
              text: '此路線不須申請入園證',
            });
          }
        }
      } else {
        // 單攻
        if (this.passRule.parkPass) {
          if (this.passRule.areaHouseRule !== null) {
            const areaRule = this.passRule.areaHouseRule;

            const endTime = moment(this.journey.startDate).subtract(5, 'day');
            endTime.set('hour', parseInt(areaRule.regCloseTime.split(':')[0]));
            endTime.set('minute', parseInt(areaRule.regCloseTime.split(':')[1]));
            let timeOver = false;
            if (moment().isAfter(endTime)) {
              timeOver = true;
            }

            d.subtract(areaRule.regOpenDateRule === 0?2:1, 'month');
            if (d.date() !== originDate) {
              d.add(1, 'day');
            }
            const regMsg = {
              date: d.format('MM/DD'),
              time: areaRule.regOpenTime,
              text: '開始申請',
            }
            if (!timeOver) {
              regMsg.link = areaRule.regLink;
              regMsg.linkText = '前往登記';
              // this.setParkSubmitCalendar(d, areaRule.regOpenTime, areaRule.regLink);
            }
            this.parkPassDesc.push(regMsg);

            d = moment(this.journey.startDate).subtract(5, 'day');
            this.parkPassDesc.push({
              date: d.format('MM/DD'),
              time: areaRule.regCloseTime,
              text: '截止申請',
            });
          } else {
            this.parkPassDesc.push({
              text: '此路線須申請入園證',
            });
          }
        } else {
          this.parkPassDesc.push({
            text: '此路線不須申請入園證',
          });
        }
      }
    },
    __calcMountainPassDesc() {
      if (this.passRule.mountainPass) {
        // 需要入山證
        let d = moment(this.journey.startDate).subtract(124, 'day');
        let d2= moment(this.journey.startDate).subtract(3, 'day');

        d2.set('hour', 23);
        d2.set('minute', 59);
        let timeOver = false;
        if (moment().isAfter(d2)) {
          timeOver = true;
        }

        let dateStr = `${d.format('MM/DD')} ~ ${d2.format('MM/DD')}`;
        const regMsg = {
          date: dateStr,
          text: '申請入山證',
        }
        if (!timeOver) {
          regMsg.link = 'https://nv2.npa.gov.tw/NM107-604Client/';
          regMsg.linkText = '前往申請';
        }
        this.mountainPassDesc.push(regMsg);
      } else {
        // 不需要入山證
        this.mountainPassDesc.push({
          text: '此路線不須申請入山證',
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.journey.detail {
  .master-info {
    gap: 1rem;
    .avatar {
      border: 2px solid $color-dark;
    }
    .fs-title-14 {
      color: $color-bk-tp-50;
    }
  }
  .apply-btn {
    width: 33%;
    @include smaller-than-medium {
      width: 100%;
    }
  }
  .journey-content.journey-block {
    padding: 0;
    @include smaller-than-medium {
      padding: .5rem 1rem;
    }
  }
  .climb-rate-group {
    gap: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: start;
  }
  .day-climb-rate {
    gap: .875rem;
    display: flex;
    align-items: start;
  }
  .climb-rate-number {
    gap: .25rem;
  }
  .climb-rate-text {
    color: $color-bk-tp-25;
  }
}
</style>
<style lang="scss">
  @import "src/assets/scss/journey";
</style>
